// removed by extract-text-webpack-plugin
module.exports = {"separator":"separator--separator--3o2c_Mf0"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Separator/separator.scss
// module id = 600
// module chunks = 0